/**
 * Navigation scripting.
 */
import passiveEvents from 'util/passive-events'
import forEach from 'util/for-each'
import throttle from 'lodash/throttle'

// State CSS class references.
const states = {
    open: 'is-open',
    active: 'is-active'
}

const navDropdowns = document.querySelectorAll('.js-navDropdown')
const stickyNav = document.querySelector('.js-stickyNav')
let openDropdownRef

forEach(navDropdowns, (elem) => {
    elem.addEventListener('click', (e) => {
        // Remove class if there is a currently opened dropdown.
        if (openDropdownRef && openDropdownRef !== elem) {
            openDropdownRef.classList.remove(states.open)
        }

        // Reset reference.
        openDropdownRef = (elem.classList.contains(states.open)) ? null : elem

        // Toggle current elem.
        elem.classList.toggle(states.open)
    })
})

// Sticky functionality.
let isStuck

// Sticky header functions.
function stick () {
    stickyNav.classList.add('is-sticking')

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            stickyNav.classList.add('is-stuck')
            stickyNav.classList.remove('is-sticking')
        })
    })
}

function unstick () {
    stickyNav.classList.add('is-unsticking')

    // Timeout needs to match CSS transition delay time.
    window.setTimeout(() => {
        stickyNav.classList.remove('is-unsticking', 'is-stuck')
    }, 200)
}

function applySticky () {
    const offset = window.pageYOffset

    // Any scroll > 150px sends the user into "stuck mode".
    if (offset > 150) {
        if (!isStuck) stick()
        isStuck = true

        // Hide dropdown on scroll
        if (openDropdownRef) openDropdownRef.classList.remove(states.open)
    } else {
        if (isStuck) unstick()
        isStuck = false
    }
}

// Use the feature detect's results. Passive will be applied if supported, capture will be false either way.
window.addEventListener('scroll', throttle(applySticky, 100), passiveEvents ? { passive: true } : false)

/**
 * Mobile navigation scripting.
 */

function toggleMobileDropdowns (target) {
    const dropdown = target.nextSibling
    if (!dropdown.classList.contains(states.open)) {
        target.classList.add(states.active)
        dropdown.classList.add(states.open)
    } else {
        target.classList.remove(states.active)
        dropdown.classList.remove(states.open)
    }
}

const mobileDropdowns = document.querySelectorAll('.js-mobileDropdown')

forEach(mobileDropdowns, (elem) => {
    elem.addEventListener('click', (e) => {
        e.preventDefault()
        toggleMobileDropdowns(elem)
    })
})
